// Jedyne źródło prawdy dla kształtu dokumentu usersData.
// Każda ścieżka tworząca nowe konto MUSI używać tej fabryki, aby dokument
// zawsze miał komplet pól — w szczególności obie tablice *RegisteredProducts
// jako [] (a nie undefined), co jest warunkiem bezpieczeństwa przeliczania rankingu.
export function createDefaultUserData(email: string): any {
  return {
    userEmail: (email ?? '').toLowerCase(),
    buildingNumber: "",
    city: "",
    voivodeship: "",
    companyAddress: "",
    companyName: "",
    nipCode: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    postalCode: "",
    streetName: "",
    registered: false,
    isAirConditionStatutAccepted: false,
    isPumpStatutAccepted: false,

    airConditionPoints: 0,
    airConditionPosition: 0,
    airConditionPrizeAmount: 0,
    airConditionRegisteredProducts: [],

    pumpPoints: 0,
    pumpPosition: 0,
    pumpPrizeAmount: 0,
    pumpRegisteredProducts: []
  };
}
